import React, { Component } from 'react';
import { Drawer, Button } from '@blueprintjs/core';
import {
	DrawerHeader,
	PlainButton,
	Table,
	TableHeader,
	TableData,
	Container
} from 'components/styled-components';
import { IconNames } from '@blueprintjs/icons';
import colors from 'utils/colors';
import cloneDeep from 'lodash/cloneDeep';
import Select from 'react-select';
import {
	HeaderControls,
	ScrollWrapper,
	TableRow,
	Wrapper
} from 'containers/Manage-Questionnaire/styled-components';

class PrescreenReorderDrawer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			questions: []
		};
	}

	componentDidUpdate(prevProps){
		if(
			(JSON.stringify(prevProps.questions) !== JSON.stringify(this.props.questions))
			|| (prevProps.isOpen === false && this.props.isOpen === true)
		){
			this.updateQuestions();
		}
	}

	updateQuestions = () => {
		const newQuestions = cloneDeep(this.props.questions.result);
		this.setState({questions: newQuestions});
	}

	handleCloseDrawer = () => {
		// handle any local 'cleanup' before we use the parent's method for closing the drawer
		this.props.closeDrawer();
	};

	handleSaveOrder = () => {
		const updatedQuestions = cloneDeep(this.state.questions);
		this.props.handleSaveOrder(updatedQuestions);
	}

	handleChangeOrder = (value, key) => {
		const previousOrder = this.state.questions[key].displayOrder;
		const newOrder = value.value;
		
		let newQuestions = cloneDeep(this.state.questions)
							.map(question => { //re-order the rest of the questions
								if(newOrder < previousOrder){
									if(question.displayOrder >= newOrder && question.displayOrder < previousOrder){
										question.displayOrder = question.displayOrder + 1;
									}
								}else{
									if(question.displayOrder <= newOrder && question.displayOrder > previousOrder){
										question.displayOrder = question.displayOrder - 1;
									}
								}
								return question;
							})

		newQuestions[key].displayOrder = value.value;
		this.setState({questions: newQuestions});
	}

	render() {
		const { isOpen } = this.props;
		const { questions } = this.state;

		return (
			<Drawer isOpen={isOpen} onClose={this.handleCloseDrawer}>
				<DrawerHeader>
					Re-order Pre-Screen Questions
					<HeaderControls>
						<Button icon={IconNames.CROSS} onClick={this.handleCloseDrawer} minimal />
					</HeaderControls>
				</DrawerHeader>
				<ScrollWrapper>
					<Container background={colors.whiteGray} width="95%">
						<Wrapper>
							<Table>
								<tbody>
									<TableRow>
										<TableHeader>Question</TableHeader>
										<TableHeader>Order</TableHeader>
									</TableRow>
									{questions.map((psq, pskey) => {
										return (
											<TableRow key={`prscreen-reorder-${pskey}`}>
												<TableData>{psq.question}</TableData>
												<TableData>
													<Select
														onChange={(thing) => this.handleChangeOrder(thing, pskey)}
														value={{ label: psq.displayOrder, value: psq.displayOrder }}
														options={questions.map((v,k) => {
															return { label: k+1, value: k+1 };
														})}
													/>
												</TableData>
											</TableRow>
										)
									})}
								</tbody>
							</Table>
						</Wrapper>
					</Container>
					<PlainButton style={{marginLeft: "0", display: "block", marginBottom: "1rem"}} onClick={this.handleSaveOrder}>Save Order</PlainButton>
				</ScrollWrapper>
			</Drawer>
		);
	}
}

export default PrescreenReorderDrawer;